import { render, staticRenderFns } from "./RemoveQuoteDaysDialog.vue?vue&type=template&id=2b8d686e&scoped=true"
import script from "./RemoveQuoteDaysDialog.vue?vue&type=script&lang=js"
export * from "./RemoveQuoteDaysDialog.vue?vue&type=script&lang=js"
import style0 from "./RemoveQuoteDaysDialog.vue?vue&type=style&index=0&id=2b8d686e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8d686e",
  null
  
)

export default component.exports